import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './FontFamily.css';
import { changeTextProperty } from '../../../redux/actions/entities/texts';
import getFontFamilies from './Fonts';

class FontFamily extends Component {
  constructor(props) {
    super(props);

    const { lang } = this.props;
    this.fonts = getFontFamilies(lang);
    this.handleChange = this.handleChange.bind(this);
  }


  options = () => Object.values(this.fonts).map(element => <option key={`font-${element.font}`} value={element.font}>{element.name}</option>)

  handleChange(event) {
    const { textFieldId } = this.props;
    const { value } = event.target;
    this.props.dispatch(changeTextProperty(textFieldId, 'font', value));
  }

  render() {
    return (
      <select name="fontFamily" value={this.props.font} onChange={this.handleChange}>
        { this.options() }
      </select>
    );
  }
}

FontFamily.defaultProps = {
  textFieldId: 0,
  font: 'Allura',
  dispatch: () => {},
  lang: {},
};

FontFamily.propTypes = {
  textFieldId: PropTypes.number,
  font: PropTypes.string,
  dispatch: PropTypes.func,
  lang: PropTypes.object,
};

export default connect()(FontFamily);




// WEBPACK FOOTER //
// ./src/components/text-tools/font-family/FontFamily.jsx